/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config
import QUERY from '@jira/servicedesk__virtual-agent-knowledge-base-touchpoint/src/__generated__/VirtualServiceAgentCtaCardQuery$parameters.ts';
import type { VirtualServiceAgentCtaCardQuery } from '@jira/servicedesk__virtual-agent-knowledge-base-touchpoint/src/__generated__/VirtualServiceAgentCtaCardQuery.graphql.ts';
import type { PreloadedQuery } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

export const virtualAgentKnowledgebaseTouchpointResource: RouteResource<
	PreloadedQuery<VirtualServiceAgentCtaCardQuery, Record<string, unknown>>
> = createRelayResource<VirtualServiceAgentCtaCardQuery>({
	type: 'SERVICEDESK_VIRTUAL_AGENT_KNOWLEDGE_BASE_TOUCHPOINT',
	isBrowserOnly: true,
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: QUERY,
		variables: {
			cloudId: tenantContext.cloudId,
			key: match.params.projectKey || '',
			checkForAiEnabledFF: fg('require_ai_enabled_for_jsm_virtual_agent'),
		},
	}),
});
